module.exports = __webpack_public_path__ + "media/images/broniec-hover-a09e34e7b2aac3aba545ef9eb41ac4de.jpg";